import { c as _c } from "react/compiler-runtime";
import { Icon, IconSize } from '@sbt-web/ui';
import { socialLinkSendClick } from './tracking';
import { ShopSocialProps, SocialLink } from './types';
import classes from './index.module.scss';
export const ShopSocial = t0 => {
  const $ = _c(16);
  const {
    item,
    social: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const social = t2;
  const {
    facebook,
    instagram,
    linkedin
  } = social;
  let t3;
  if ($[2] !== facebook) {
    t3 = {
      platform: "Facebook",
      url: facebook
    };
    $[2] = facebook;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== instagram) {
    t4 = {
      platform: "Instagram",
      url: instagram
    };
    $[4] = instagram;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== linkedin) {
    t5 = {
      platform: "LinkedIn",
      url: linkedin
    };
    $[6] = linkedin;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t3 || $[9] !== t4 || $[10] !== t5) {
    t6 = [t3, t4, t5].filter(_temp);
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const socialLinks = t6;
  if (socialLinks.length === 0) {
    return null;
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span className="subheading">Contatti</span>;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== item || $[14] !== socialLinks) {
    t8 = <div className={classes.social}>{t7}<div className={classes.social__links}>{socialLinks.map(link_0 => <a href={link_0.url} key={link_0.platform} target="_blank" rel="noopener noreferrer" aria-label={`Visita la pagina ${link_0.platform}`} onClick={() => socialLinkSendClick(item, link_0.platform)}><Icon name={link_0.platform} fillColor="currentColor" iconSize={IconSize.MD} accessibleTitle={`Logo di ${link_0.platform}`} /></a>)}</div></div>;
    $[13] = item;
    $[14] = socialLinks;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
};
function _temp(link) {
  return !!link.url;
}